// Single source of truth for the public contact email (CLAUDE.md: the only
// email allowed in frontend/ is contact@math4child.com — never a personal one).
// Imported wherever a mailto link or the address is shown, so changing it is one
// edit instead of hunting ~10 hardcoded copies.
export const CONTACT_EMAIL = "contact@math4child.com";
